import React, { Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from "./components";
import Home from "./pages/home";
import Accomodation from "./pages/accomodation";
import CulinaryCompetition from './pages/culinary-competition';

const RoutersApp = () => {
    return (
        <BrowserRouter basename={`/`}>
            <Switch>
                <Fragment>
                    <App>
                        <Route path="/" exact component={Home} />
                        <Route path="/accomodation/:id" exact component={Accomodation} />
                        <Route path="/registericc" exact component={CulinaryCompetition} />
                    </App>
                </Fragment>
            </Switch>
        </BrowserRouter>
    )
}

export default RoutersApp;
